<button [ngClass]="setClasses()" class="ruckit-button btn">
  <mat-icon class="fa {{leadingIcon}}" *ngIf="leadingIcon"></mat-icon> {{title}} <mat-icon class="fa {{trailingIcon}}" *ngIf="trailingIcon"></mat-icon>
</button>
